 <template>
  <v-expansion-panel-content>
    <div slot='header'>
      <div style='display: flex' class='align-center pr-4'>
        <h3>{{type}}</h3>
      </div>
    </div>

    <div style='margin-left: 20px'>
      <v-flex xs11>
        <v-text-field
          v-model='value.key'
          class='input-data'
          filled
          clearable
          required
          label='Key'
          :rules="[v => !!(v || '').trim() || 'Required']"
        ></v-text-field>
      </v-flex>
      <v-flex xs11>
        <v-text-field
          v-model='value.secret'
          label='Secret'
          class='input-data'
          filled
          clearable
          required
          :type="showSerect ? 'text' : 'password'"
          :append-icon="showSerect ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showSerect = !showSerect"
          :rules="[v => !!(v || '').trim() || 'Required']"
        ></v-text-field>
      </v-flex>
      <v-flex xs11>
        <v-text-field
          v-model='value.id'
          label='Id'
          class='input-data'
          filled
          clearable
        ></v-text-field>
      </v-flex>
      <v-flex xs11>
        <v-text-field
          v-model='value.password'
          label='Password'
          class='input-data'
          filled
          clearable
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
      </v-flex>
      <v-flex xs11>
        <v-text-field
          v-model='value.passphase'
          label='Passphase'
          class='input-data'
          filled
          clearable
        ></v-text-field>
      </v-flex>
    </div>
  </v-expansion-panel-content>
</template>

<script>
export default {
  props: {
    value: { type: Object, require: true },
    type: { type: String, require: true }
  },
  data() {
    return {
      showSerect: false,
      showPassword: false
    }
  },
}
</script>